import { assetServices } from "../../../services";

// Fetch all assets
export async function assetsLoader() {
  try {
    const query = "?status=available&limit=20&page=1";
    const res = await assetServices.allAssets(query);
    if (!res)
      throw new Response(
        "Failed to load assets. Please check that your network connectivities are okay",
        { status: 404 },
      );
    return res;
  } catch (err) {
    throw new Response("Failed to load assets", { status: 500 });
  }
}

// Featured assets
export async function featuredAssetsLoader() {
  try {
    const query = "?status=featured&limit=20&page=1";
    const res = await assetServices.allAssets(query);
    if (!res)
      throw new Response(
        "Failed to load featured assets. Please check that your network connectivities are okay",
        { status: 404 },
      );
    return res;
  } catch (err) {
    throw new Response("Failed to load featured assets", { status: 500 });
  }
}

// Assets by platform
export async function assetsByPlatformLoader({ params }) {
  const { platform, category } = params;
  const query = `?page=1&limit=20&status=available`;
  try {
    const response = await assetServices.getAssetsByCategoryName(
      platform,
      category || "",
      query,
    );
    console.log(response);
    if (!response)
      throw new Response(
        `Failed to load ${(platform, category || "")} assets. Please check that your network connectivities are okay`,
        { status: 404 },
      );
    return response;
  } catch (error) {
    if (error.message === "Platform not found") {
      return [];
    } else {
      throw new Response("Failed to load assets", { status: 500 });
    }
  }
}

export async function assetDetailLoader({ params }) {
  const { id } = params;
  if (!id) throw new Response("Asset ID missing", { status: 400 });

  try {
    const asset = await assetServices.getAsset(id);
    if (!asset) throw new Response("Asset not found", { status: 404 });
    return { asset };
  } catch (err) {
    throw new Response("Failed to load asset", { status: 500 });
  }
}

export async function userAssetsLoader({ params }) {
  const { username } = params;

  try {
    const query = `?limit=20&page=1&status=available`;
    const res = await assetServices.getAssetsByUsername(username, query);

    if (!res || !res.data) {
      throw new Response("No assets found for this user", { status: 404 });
    }

    return {
      initialAssets: res.data,
      meta: res.meta,
      username,
    };
  } catch (err) {
    throw new Response(err.message || "Failed to fetch assets", {
      status: 500,
    });
  }
}
